
import { data } from '~/node_modules/autoprefixer/lib/autoprefixer';

export default {
  name: 'FaqAccordion',
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      faqs: [],
      isReady: false,
    };
  },
  async fetch() {
    try {
      const response = await fetch(`${this.$config.apiBaseUrl}/data`, {
        method: 'POST',
        lazy: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `Command=faqs&section=${this.section}&Language=${this.$i18n.locale}`,
      })

      var data = await response.json()
      this.faqs = data.Children
      this.$nextTick(() => {
        this.$emit('ready'); // tell parent we’re ready
      });
    } catch (error) {
      // console.log(error)
    }
  },
  async mounted() {
    // do whatever async init you need
    this.isReady = true;
    this.$nextTick(() => {
      this.$emit('ready'); // tell parent we’re ready
    });
  },
}
